<app-profile-summary title="{{summaryTitle}}" firstSectionText="{{summaryPart1}}" secondSectionText="{{summaryPart2}}" linkToCode="{{linkToCode}}" linkToWebsite="{{linkToWebsite}}"></app-profile-summary>
<app-budget-instructions></app-budget-instructions>

